import { lazyLoad } from 'utils/loadable';

export const DishPage = lazyLoad(
  () => import('./index'),
  module => module.DishPage,
);
